import { KYMW0600Model } from '../kymw0600.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * Pコードを指定し、商品情報を取得するクラス
 *
 * @export GetTargetRelationPcodeGoodsInfoService
 * @class GetTargetRelationPcodeGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetTargetRelationPcodeGoodsInfoService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0600Model;
  private pCode: string;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTargetRelationPcodeGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.pCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTargetRelationPcodeGoodsInfoService
   */
  execute(model: KYMW0600Model, pCode: string, successFunc: Function = null): void {
    this.model = model;
    this.pCode = pCode;
    this.send('getTargetRelationPcodeGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTargetRelationPcodeGoodsInfoService
   */
  success(data: any): void {
    // サーバからの結果を元に、商品情報データを更新する
    this.model.updateRelatedInfo(data, this.pCode);
  }
}
